// @ts-ignore
import throttle from 'lodash/throttle';

export class MainMenuClass {
    toggleTargets: NodeListOf<HTMLElement>;
    menuToggle: HTMLElement;
    toggleClass: string;

    constructor() {
        this.toggleClass = 'menu-toggled';
        this.toggleTargets = document.querySelectorAll("[data-menu-toggle='target']");
        this.menuToggle = document.querySelector("[data-menu-toggle='trigger']");
        this.init();
    }

    init() {
        this.addTriggerEvents();
    }

    addTriggerEvents() {
        this.menuToggle.addEventListener('click', (e) => {
            this.toggleTargets.forEach((targetElement) => {
                this.toggleClasses(targetElement);
            })
        })

        window.addEventListener('resize', throttle(() => {
            if (window.innerWidth > 900) {
                this.toggleTargets.forEach((targetElement) => {
                    this.toggleClasses(targetElement, true);
                })
            }
        }, 250));
    }

    toggleClasses(element: HTMLElement, removeClass = false) {
        if (removeClass) {
            element.classList.remove(this.toggleClass);
            return;
        }

        if (element.classList.contains(this.toggleClass)) {
            element.classList.remove(this.toggleClass);
        } else {
            element.classList.add(this.toggleClass);
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    new MainMenuClass();
});
